export default __webpack_public_path__ + "angularjs.c6b9868c.png";